import React from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'

import { Title } from '@/modules/base/components/texts/index'
import SimpleAgGrid from '@/modules/base/components/simple-ag-grid/simple-ag-grid'

const { massImport: texts } = lang

const MassImportPreview = (props) => {
  const {
    importData,
  } = props

  const classes = useStyles()

  const columns = Object.keys(importData.columns).map((key) => ({
    field: key,
    headerName: `${importData.columns[key]} (${key})`,
    resizable: true,
    sort: false,
    lockPinned: true,
    suppressMovable: true,
    cellStyle: { textAlign: 'left' },
    menuTabs: [],
    valueFormatter: ({ value }) => value?.value,
  }))

  const rowData = importData.rows.slice(0, 4)

  return (
    <div className={classes.container}>
      <Title>{texts.preview}</Title>
      <div className={classes.list}>
        <SimpleAgGrid
          domLayout='autoHeight'
          columns={columns}
          data={rowData}
          rowClass={classes.row}
          localeText={{
            noRowsToShow: lang.accounting.list.noRowsToShow,
            loadingOoo: lang.accounting.list.loadingOoo,
          }}
          autoFitColumns={false}
          showBorder={false}
        />
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  loader: {
    height: '100%',
    top: 85,
  },
  importActive: {
    textAlign: 'center',
  },
  container: {
    padding: '32px 29.1px 22.5px 32.2px',
    borderRadius: '4px',
    border: theme.border,
    backgroundColor: '#fff',
  },
  dataImportContent: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    background: '#ffffff',
    overflow: 'auto',
  },
  dataImportContinueButton: {
    marginLeft: '15px',
  },
  dataImportCancelButton: {
    marginLeft: '15px',
  },
  list: {
    '& .ag-header-cell': {
      alignItems: 'center',
    },
  },
}))

export default MassImportPreview
